import { defineStore } from 'pinia'
import state from './common/state'
import actions from './common/actions'

export const useCampaignsStore = defineStore('campaigns', {
  state,
  actions
})
